import { CardMedia, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React from "react";
import about2 from "../assets/images/about2.png";
import about3 from "../assets/images/about3.png";
import about4 from "../assets/images/about4.png";
import backgroundAbout from "../assets/images/backgroundAbout.png";
import { TitleText } from "../components/common/TitleText";
import { ContentContainer } from "../layout/ContentContainer";
import Subscribe from "./component/Subscribe";

const About = () => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "600px",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            color: "white",
            zIndex: "7 !important",
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h4"
            component="h4"
            sx={{ fontSize: { md: "40px" }, marginTop: { md: "-100px" } }}
          >
            Make, Mint, Merge
          </Typography>
          ;
          <Box sx={{ width: { md: "50%", xs: "90%" }, textAlign: "center" }}>
            <Typography
              variant="h6"
              component="h6"
              sx={{
                fontSize: { md: "20px" },
                lineHeight: { md: "27px" },
              }}
            >
              big beyond believes that NFTs are the gateways to connecting and
              merging the physical world of today, with the many digital worlds
              of the future. By incentivising NFT ownership through our unique,
              yield-bearing NFT collections, we hope to inspire the masses to
              take their first step into the big beyond.
            </Typography>
          </Box>
        </Box>
        <img
          src={backgroundAbout}
          style={{
            height: "100%",
            width: "100%",
            objectFit: "cover",
            position: "absolute",
          }}
          alt="about-us-header"
        />
      </Box>

      <ContentContainer>
        <Box
          sx={{
            minHeight: 500,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "10px 0px",
          }}
        >
          <Box
            sx={{
              width: { md: "770px" },
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: 3,
              marginTop: { md: "40px" },
            }}
          >
            <img
              src={about2}
              style={{ height: "100%", width: "100%" }}
              alt="about-us-section1"
            />
            <TitleText
              variant="h4"
              component="h4"
              sx={{ marginTop: { md: "25px", xs: "10px" } }}
            >
              make
            </TitleText>
            <Typography
              variant="h6"
              component="h6"
              fontSize="12px"
              lineHeight="14.4px"
              sx={{
                textAlign: "center",
                width: "70%",
                marginBottom: { md: "30px", xs: "20px" },
              }}
            >
              With Big Beyond’s exclusive NFT collections, just buying and
              owning them earns you returns and on a monthly basis no less.
            </Typography>
          </Box>
        </Box>

        <Box
          sx={{
            width: { md: "770px" },
            display: "flex",
            justifyContent: "center",
            margin: "10px 0px",
            marginBottom: "50px",
          }}
        >
          <Grid
            container
            direction="row"
            alignItems="stretch"
            sx={{ marginTop: { md: "40px" } }}
          >
            <Grid
              md={6}
              item
              xs={12}
              sx={{ marginTop: { xs: "10px", md: "0px" } }}
            >
              <Box
                sx={{
                  height: { md: "420px" },
                  boxShadow: 2,
                  paddingBottom: 2,
                  marginRight: { md: "13px" },
                }}
              >
                <CardMedia
                  component="img"
                  image={about3}
                  style={{
                    height: "250px",
                  }}
                  alt="about-us-section2"
                />
                <TitleText
                  sx={{
                    textAlign: "center",
                    marginTop: { md: "32px", xs: "16px" },
                  }}
                  variant="h4"
                  component="h4"
                >
                  mint
                </TitleText>

                <Box display="flex" justifyContent="center">
                  <Typography
                    sx={{ textAlign: "center" }}
                    variant="h6"
                    component="h6"
                    fontSize="12px"
                    lineHeight="14.4px"
                    width="70%"
                  >
                    An aspiring artist, designer or creative? Start your minting
                    journey with us and our community. Inspire and be inspired.
                    Creativity is a 2-way street.
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid
              md={6}
              item
              xs={12}
              sx={{ marginTop: { xs: "10px", md: "0px" } }}
            >
              <Box
                sx={{
                  marginLeft: { xs: "0px", md: "12px" },
                  height: { md: "420px" },
                  boxShadow: 2,
                  paddingBottom: 2,
                }}
              >
                <CardMedia
                  component="img"
                  image={about4}
                  style={{
                    height: "250px",
                  }}
                  alt="about-us-section3"
                />

                <TitleText
                  sx={{
                    textAlign: "center",
                    marginTop: { md: "32px", xs: "16px" },
                  }}
                  variant="h4"
                  component="h4"
                >
                  merge
                </TitleText>
                <Box display="flex" justifyContent="center">
                  <Typography
                    sx={{ textAlign: "center" }}
                    variant="h6"
                    component="h6"
                    fontSize="12px"
                    lineHeight="14.4px"
                    width="70%"
                  >
                    Print your NFT collections into t-shirts and wear it in the
                    real world. Digital twin in your metaverse, no problem.
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Subscribe />
      </ContentContainer>
    </>
  );
};

export default About;
